export default __webpack_public_path__ + "static/media/about-plot-3.52deb284.jpg";